import filter from "lodash/filter";
import { useEffect, useRef, useState } from "react";
import styles from "./T11_PlanCard.module.scss";
import { ButtonCust } from "../../../widgets/Button/ButtonCust";
import Config from "../../../../config/env.config.json";
import {
  calculateCost,
  calculateUnlimitedCostMnM,
  PlanProps,
} from "./PlanCard";
import {
  Box,
  LinearProgress,
  linearProgressClasses,
  styled,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import clsx from "clsx";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { Coupon } from "../../../../features/checkout/checkoutSlice";
import {
  useNonInitialEffect,
  caclulatePlanCostBasedOnEligibility,
} from "../../../../utils/commonFunctions";
import _ from "lodash";
import EnvConfig from "../../../../config/env.config.json";
import { useNavigate } from "react-router-dom";
import { showSSOModalFn } from "../../../../features/homepage/homepageSlice";
import { RoutingURLs } from "../../../../config/RoutingURLs";
import unlimitedPlanDiscount from "../../../../config/discountCouponMNM.json";
import { SimpleModal } from "../../../widgets";
import { gtmTagManager } from "../../../../utils/commonFunctions/GtmTagManager";
import { NutritionLabel } from "../NutritionLabel/NutritionLabel";

export const priceCalculationHandler: any = (
  data: any,
  selectedLine: any = 1
) => {
  let PlanDiscountCost, planPerLinesCost: any;
  if (data?.isUnlimited) {
    const { planCost } = calculateUnlimitedCostMnM(data, selectedLine, false);
    PlanDiscountCost = caclulatePlanCostBasedOnEligibility(
      planCost,
      unlimitedPlanDiscount.data[0].discountInDollar * selectedLine
    );
  } else {
    const { planCost } = calculateCost(data, selectedLine);
    PlanDiscountCost = caclulatePlanCostBasedOnEligibility(
      planCost,
      unlimitedPlanDiscount.data[0].discountInDollar * selectedLine
    );
  }
  planPerLinesCost = PlanDiscountCost / selectedLine;
  return planPerLinesCost;
};

const T11_PlanCard = (props: PlanProps) => {
  const dispatch: any = useAppDispatch();
  const navigate = useNavigate();

  const { coupon, getAppData } = useAppSelector((state: any) => state.checkout);
  const { configKeys } = useAppSelector((state: any) => state?.activation);

  const [planCost, setPlanCost] = useState(0);
  const [planUnlimitedCost, setPlanUnlimitedCost] = useState(0);
  const [shareablePlans, setShareablePlans] = useState<any>(null);
  const [unlimitedPlans, setUnlimitedPlans] = useState<any>(null);
  const [user, setUser] = useState<any>(null);
  const [customerEligibility, setCustomerEligibility] = useState<any>(null);
  const [openModal, setOpenModal] = useState<any>(false);
  const [isSSOToken, setIsSSOToken] = useState<boolean>(false);
  const [selectedPlanDetail, setSelectedPlanDetail] = useState<any>([]);
  const [showSSOModal, setShowSSOModal] = useState<boolean>(false);
  const [filteredPlans, setFilteredPlans] = useState<any>({});
  const [customer, setCustomer] = useState<any>({});
  const {
    planContent,
    isSimPaid,
    plandata,
    selectedLine,
    planSelectionHandler,
    getCustomer,
  } = props;
  const {
    by_gig,
    desc,
    dollar,
    gb,
    gb_data,
    hd_stream,
    per_month,
    sd_stream,
    select_plan,
    title,
    stream_img,
    data_img,
    unlimited,
    unlimited_data,
    unlimited_hd,
    max_lines,
    lines_selected,
    no_of,
    checkout_cta,
    bill_calc_title,
    bill_calc_cta,
    failure_icon,
    hsi_info_title,
    hsi_info_subtitle,
    plan_features,
    unlmtd_img,
    hotspot_img,
    no_hotspot_img,
  } = planContent || {};

  let ssoCustomerInfo: any = localStorage.getItem("ssoCustomerInfo");
  ssoCustomerInfo = JSON.parse(ssoCustomerInfo);
  let ssoAccessToken: any = localStorage.getItem("ssoAccessToken");
  const [showModal, setShowModal] = useState<boolean>(false);
  const { globalVal } = useAppSelector(
    (state: any) => state?.strapi?.globalValues || {}
  );

  useEffect(() => {
    const sharedPlanData = filter(plandata, { isUnlimited: false });
    const selectedPlanData = sharedPlanData[0];
    setSharableCost(selectedPlanData);
    const unlimitedPlan = filter(plandata, { isUnlimited: true });
    setUnlimitedCost(unlimitedPlan[0]);
    setShareablePlans(selectedPlanData);
    setUnlimitedPlans(unlimitedPlan[0]);

    let customerDetail: any = localStorage.getItem("customerDetail");
    customerDetail = JSON.parse(customerDetail);
    let selectedPlans: any = localStorage.getItem("reachSelectedPlanDetail");
    selectedPlans = JSON.parse(selectedPlans);
    if (selectedPlans?.length > 0) {
      setSelectedPlanDetail(selectedPlans);
    }

    setUser(customerDetail);

    // let ssoAccessToken: any = localStorage.getItem("ssoAccessToken");
    if (ssoAccessToken) {
      setIsSSOToken(true);
    }

    if (ssoCustomerInfo) {
      setCustomerEligibility(
        ssoCustomerInfo?.customer_eligibility ? false : true
      );
      setOpenModal(true);
    }
    if (ssoCustomerInfo?.promo_code) {
      plandata?.map((plan: any) => {
        dispatch(
          Coupon({
            couponCode: `${ssoCustomerInfo?.promo_code.toUpperCase()}_${
              plan?.serviceCode
            }`,
          })
        );
      });
    }
  }, []);

  useEffect(() => {
    if (getCustomer) {
      setCustomer(getCustomer);
    }
  }, [getCustomer]);

  const initialRender = useRef(true);
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      if (shareablePlans || unlimitedPlans) {
        setSharableCost(shareablePlans);
        setUnlimitedCost(unlimitedPlans);
      }
    }
  }, [selectedLine]);
  const initialDialogRender = useRef(true);
  useNonInitialEffect(() => {
    if (ssoCustomerInfo) {
      if (initialDialogRender.current) {
        if (!ssoCustomerInfo?.mobile_discount_qualified) {
          setShowModal(true);
        }
        initialDialogRender.current = false;
      }
    }
  }, [ssoCustomerInfo]);

  useNonInitialEffect(() => {
    localStorage.setItem(coupon?.coupon, JSON.stringify(coupon));
    if (shareablePlans || unlimitedPlans) {
      setSharableCost(shareablePlans);
      setUnlimitedCost(unlimitedPlans);
    }
  }, [coupon]);

  useNonInitialEffect(() => {
    localStorage.setItem(
      "reachSelectedPlanDetail",
      JSON.stringify(selectedPlanDetail)
    );

    let countByName = count(selectedPlanDetail, (item: any) => {
      return item?.plan?.displayName;
    });
    setFilteredPlans(countByName);
  }, [selectedPlanDetail]);

  const count = (ary: any, classifier: any) => {
    classifier = classifier || String;
    return ary.reduce(function (counter: any, item: any) {
      var p = classifier(item);
      counter[p] = counter.hasOwnProperty(p) ? counter[p] + 1 : 1;
      return counter;
    }, {});
  };
  const selectPlanHandler = (
    _: any,
    plan: any,
    type?: string,
    firstLine?: boolean
  ) => {
    let planDetails;
    if (type === "add") {
      if (selectedPlanDetail.length + 1 <= max_lines) {
        let currentPlan = {
          // line: "line" + (selectedPlanDetail.length + 1),
          plan: plan,
          nickName: "",
          imei: "",
          simPreference: "",
          isPrimary: "",
          // discountedPrice: priceCalculationHandler(plan?.baseLinePrice) || 0,
        };
        planDetails = [...(selectedPlanDetail || []), currentPlan];
        setSelectedPlanDetail(planDetails);
      }
      if (firstLine) {
        gtmTagManager({
          event: `mobile_${plan?.planData}gb_select_plan`,
          click_section: "home",
        });
      } else {
        gtmTagManager({
          event: `mobile_${plan?.planData}gb_add_line`,
          click_section: "home",
        });
      }
    } else if (type === "remove") {
      gtmTagManager({
        event: `mobile_${plan?.planData}gb_remove_line`,
        click_section: "home",
      });
      let selectedPlans = selectedPlanDetail.reverse();
      for (let i = 0; i < selectedPlans?.length; i++) {
        if (selectedPlans[i].plan?.displayName === plan?.displayName) {
          selectedPlans?.splice(i, 1);
          break;
        }
      }
      let updatedPlans = [...selectedPlans]; // changing the reference so that component is rerendered
      setSelectedPlanDetail(updatedPlans);
    }
    // gtmTagManager({
    //   event: gaScreenNames.signup,
    //   signup_method: "Google Signup",
    // });
    // if (type === "byTheGig") {
    //   data = shareablePlans;
    // } else {
    //   data = unlimitedPlans;
    // }
    // planSelectionHandler(data, byTheGig.buttonTxt);
    // pushTrackingEventsToGAAndFB(gaEventTypes.event, gaEventTypes.click, {
    //   appName: Config.brand,
    //   screenName: gaScreenNames.plan,
    //   category: `${plan && plan?.name} ${selectedLine}`,
    //   buttonValue: byTheGig.buttonTxt,
    // });

    // localStorage.setItem("reachSelectedPlanLine", JSON.stringify(selectedLine));
    // localStorage.setItem(
    //   "reachSelectedPlanDetail",
    //   JSON.stringify(selectedPlanDetail)
    // );
  };

  const getPlanCost = (plan: any, coupon: any) => {
    let planCost: any;
    if (plan?.addLineSplitPrice && selectedLine > 1) {
      let linePrice1 = 0;
      for (let i = 1; i <= selectedLine - 1; i++) {
        linePrice1 = linePrice1 + plan?.addLineSplitPrice[i];
      }
      planCost =
        plan?.baseLinePrice -
        coupon?.discountInDollar +
        (linePrice1 - coupon?.secondaryDiscountInDollar * (selectedLine - 1));
    } else {
      planCost =
        plan?.baseLinePrice -
        coupon?.discountInDollar +
        (selectedLine - 1) *
          (plan?.additionalLinePrice - coupon?.secondaryDiscountInDollar);
    }
    return (
      planCost ||
      plan?.baseLinePrice + (selectedLine - 1) * plan?.additionalLinePrice
    );
  };

  const setUnlimitedCost = (data: any) => {
    const planDiscount = JSON.parse(
      localStorage.getItem(
        `${ssoCustomerInfo?.promo_code?.toUpperCase()}_${data?.serviceCode}`
      ) || "null"
    );
    let planCost: any = getPlanCost(data, planDiscount);

    setPlanUnlimitedCost(planCost);
    setUnlimitedPlans(data);
  };

  const setSharableCost = (data: any) => {
    const planDiscount = JSON.parse(
      localStorage.getItem(
        `${ssoCustomerInfo?.promo_code?.toUpperCase()}_${data?.serviceCode}`
      ) || "null"
    );
    let planCost: any = getPlanCost(data, planDiscount);

    setPlanCost(planCost);
    setShareablePlans(data);
  };

  const getQuantity = (p: any) => {
    let quantity = 0;
    selectedPlanDetail.forEach((el: any) => {
      return el?.plan?.displayName === p?.displayName && quantity++;
    });
    return quantity;
  };
  const cardStyle = {
    borderRadius: "10px",
    boxShadow: "0px 4px 6px 0px #00000026",
    width: { xs: "285px", sm: "285px", md: "285px", lg: "285px" },
    m: { xs: "0 auto 20px", md: "0 2% 20px", lg: "0 1% 20px" },
    background: "var(--white)",
    height: "442px",
  };
  const bulletPoint = {
    fontSize: "14px",
    fontWeight: "var(--font_weight_0)",
    position: "relative", // Set position to relative
    marginLeft: "1.5em", // Adjust the distance between the square bullet and text
    "::before": {
      // Define pseudo-element ::before for square bullet
      content: "''",
      width: "5px", // Adjust the size of the square bullet
      height: "5px", // Adjust the size of the square bullet
      background: "var(--checkout_secondary_light_green)", // Set the color of the square bullet
      marginRight: "0.5em", // Adjust the spacing between the square bullet and text
      display: "inline-block", // Place the square bullet inline with the text
      verticalAlign: "top", // Vertically align the square bullet with the top of the text
      position: "absolute", // Set position to absolute
      left: "-13px", // Adjust the left position to move the text to the desired starting point
      top: "8px",
    },
  };
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 3,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 3,
      backgroundColor: theme.palette.mode === "light" ? "#00A8EC" : "#DDDDDD",
    },
  }));
  const shareablePlan = filter(plandata, { isUnlimited: false });
  const unlimitedPlan = filter(plandata, { isUnlimited: true });
  const { fade_out, buttonStyle, bill_calc_btn } = styles;

  const handleTabChange = (val: any) => {};

  return (
    configKeys &&
    getAppData && (
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              fontFamily: "var(--font_family_Bold)",
              fontSize: { xs: "24px", sm: "32px", md: "40px" },
              textAlign: "center",
              color: "var(--text_color_12)",
              margin: { xs: "20px auto", sm: "0px auto 0px" },
              width: { xs: "80%", sm: "100%", md: "60%" },
            }}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          >
            {/* {title} */}
          </Typography>
          <Typography
            sx={{
              fontFamily: "var(--font_family_Medium)",
              fontSize: { xs: "16px", sm: "18px" },
              color: "var(--text_color_12)",
              width: { xs: "90%", sm: "60%" },
              textAlign: "center",
            }}
          >
            {desc}
          </Typography>
          <Box
            sx={{
              display: { xs: "block", md: "flex" },
              justifyContent: "space-evenly",
              flexWrap: "wrap",
              m: "30px auto",
              width: "100%",
            }}
          >
            {plandata?.map((p: any, i: any) => {
              const planPerLinesCost = priceCalculationHandler(p, selectedLine);

              return (
                <Box sx={cardStyle} key={p.name}>
                  <Box
                    sx={{ p: { xs: "20px 20px 10px", sm: "30px 15px 25px" } }}
                  >
                    <Box sx={{ height: "330px", padding: "0px 5px" }}>
                      <Box
                        sx={{
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "23px",
                            fontFamily: "var(--font_family_Bold) !important",
                            color: "var(--primary_brand_color)",
                            width: "98%",
                            height: "60px",
                            margin: "auto",
                          }}
                        >
                          {p?.displayName}{" "}
                          {p?.planSubType !== "PREMIUM"
                            ? `${p?.planData} ${gb}`
                            : ""}
                        </Typography>
                        {/* <Typography
                        sx={{
                          fontSize: "16px",
                          // fontWeight: "var(--font_weight_4)",
                          color: "var(--primary_brand_color)",
                          fontFamily: "var(--font_family_Semibold)",
                          width: "98%",
                          margin: "20px auto",
                        }}
                      >
                        {p.subHeading}
                      </Typography> */}
                      </Box>

                      {/* <BorderLinearProgress
                      variant="determinate"
                      value={(p?.planData / 25) * 100}
                    /> */}

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "baseline",
                          justifyContent: "center",
                        }}
                      >
                        {/* {p?.planSubType !== "PREMIUM" ? (
                        <Typography
                          sx={{
                            fontSize: "24px",
                            // fontWeight: "var(--font_weight_4)",
                            color: "var(--primary_brand_color)",
                            fontFamily: "var(--font_family_Bold)",
                            width: "40%",
                            margin: "20px auto",
                          }}
                        >
                          {p?.planData} {gb}
                        </Typography>
                      ) : null} */}
                        <Box
                          sx={{
                            textAlign: "center",
                            display: "flex",
                            alignItems: "flex-start",
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: "28px",
                              // fontWeight: "var(--font_weight_4)",
                              fontFamily: "var(--font_family_Bold)",
                              color: "var(--pink-red)",
                            }}
                          >
                            {dollar}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "40px",
                              fontWeight: "var(--font_weight_4)",
                              color: "var(--pink-red)",
                            }}
                          >
                            {/* {p.baseLinePrice.toFixed(2)}== ==== */}
                            {planPerLinesCost.toFixed(2)}
                          </Typography>
                          <Typography
                            component="span"
                            sx={{
                              fontSize: "12px",
                              fontWeight: "var(--font_weight_4)",
                              color: "var(--primary_brand_color)",
                              marginTop: "13px",
                            }}
                          >
                            {per_month}
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          margin: "20px auto",
                        }}
                      >
                        <Box
                          component="img"
                          alt={
                            unlmtd_img?.data?.attributes?.alternativeText || ""
                          }
                          height="20px"
                          width="20px"
                          src={unlmtd_img?.data?.attributes?.url || ""}
                        />
                        <Typography
                          sx={{
                            color: "var(--text_color_12)",
                            fontFamily: "var(--font_family_Bold)",
                            fontSize: "14px",
                          }}
                        >
                          {plan_features?.unlimited}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        <Box
                          component="img"
                          alt={
                            stream_img?.data?.attributes?.alternativeText || ""
                          }
                          height="20px"
                          width="20px"
                          src={
                            p?.tethering
                              ? hotspot_img?.data?.attributes?.url || ""
                              : no_hotspot_img?.data?.attributes?.url || ""
                          }
                        />
                        <Typography
                          sx={{
                            color: "var(--text_color_12)",
                            fontFamily: "var(--font_family_Bold)",
                            fontSize: "14px",
                          }}
                        >
                          {p?.tethering
                            ? p?.tethering + plan_features?.hotspot
                            : plan_features?.no_hotspot}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        <Box
                          component="img"
                          alt={
                            stream_img?.data?.attributes?.alternativeText || ""
                          }
                          height="20px"
                          width="20px"
                          src={stream_img?.data?.attributes?.url || ""}
                        />
                        <Typography
                          sx={{
                            color: "var(--text_color_12)",
                            fontFamily: "var(--font_family_Bold)",
                            fontSize: "14px",
                          }}
                        >
                          {p.planType === "HSD"
                            ? plan_features?.premium_qlty
                            : plan_features?.standard_qlty}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", gap: "10px" }}>
                        <Box
                          component="img"
                          alt={
                            data_img?.data?.attributes?.alternativeText || ""
                          }
                          height="20px"
                          width="20px"
                          src={data_img?.data?.attributes?.url || ""}
                        />
                        <Typography
                          sx={{
                            color: "var(--text_color_12)",
                            fontFamily: "var(--font_family_Bold)",
                            fontSize: "14px",
                          }}
                        >
                          {p?.planSubType === "PREMIUM"
                            ? p?.planData +
                              " " +
                              p?.dataUnit +
                              plan_features?.psd
                            : p?.planData +
                              " " +
                              p?.dataUnit +
                              plan_features?.hsd}
                        </Typography>
                      </Box>
                    </Box>

                    {getQuantity(p) === 0 ? (
                      <Box
                        sx={{ textAlign: "center" }}
                        className={clsx(
                          unlimitedPlans?.maxLines >= selectedLine
                            ? " "
                            : fade_out
                        )}
                      >
                        <ButtonCust
                          className={buttonStyle}
                          variantType={Config.PRIMARY_BUTTON_TYPE}
                          data-testid="selectPlanHandler"
                          onClick={(e: any) => {
                            // (user && EnvConfig?.IS_SSO_LOGIN) || isSSOToken
                            //   ? shareablePlans?.maxLines >= selectedLine
                            //     ? selectPlanHandler(e, "byTheGig")
                            //     : " "
                            //   : (window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`);
                            selectPlanHandler(e, p, "add", true);
                          }}
                          sx={{
                            "&:hover": {
                              backgroundColor:
                                "var(--button_hover_color) !important",
                              border:
                                "1px solid var(--button_hover_color) !important",
                            },
                          }}
                          disabled={
                            selectedPlanDetail.length >=
                            configKeys?.MAX_LINES_GROUP
                          }
                        >
                          {select_plan}
                        </ButtonCust>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          backgroundColor: "var(--primary_color)",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                          height: "50px",
                          borderRadius: "60px",
                          minWidth: "128px",
                          width: "128px",
                          margin: "auto",
                        }}
                        className={clsx(
                          unlimitedPlans?.maxLines >= selectedLine
                            ? " "
                            : fade_out
                        )}
                      >
                        <Typography
                          sx={{
                            width: "20px",
                            height: "20px",
                            color: "var(--text_color_12)",
                            textAlign: "center",
                            cursor: "pointer",
                            backgroundColor: "var(--white)",
                            border: " 1px solid var(--white)",
                            borderRadius: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={(e: any) => {
                            // (user && EnvConfig?.IS_SSO_LOGIN) || isSSOToken
                            //   ? shareablePlans?.maxLines >= selectedLine
                            //     ? selectPlanHandler(e, "byTheGig")
                            //     : " "
                            //   : (window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`);
                            selectPlanHandler(e, p, "remove");
                          }}
                        >
                          -
                        </Typography>
                        <Typography
                          sx={{
                            width: "20%",
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          {getQuantity(p)}
                        </Typography>
                        <Typography
                          sx={{
                            width: "20px",
                            height: "20px",
                            color: "var(--text_color_12)",
                            textAlign: "center",
                            cursor: "pointer",
                            backgroundColor: "var(--white)",
                            border: " 1px solid var(--white)",
                            borderRadius: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={(e: any) => {
                            // (user && EnvConfig?.IS_SSO_LOGIN) || isSSOToken
                            //   ? shareablePlans?.maxLines >= selectedLine
                            //     ? selectPlanHandler(e, "byTheGig")
                            //     : " "
                            //   : (window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`);
                            selectPlanHandler(e, p, "add");
                          }}
                        >
                          +
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              );
            })}
          </Box>

          <SimpleModal
            isShowModal={showModal}
            onCloseModal={() => {
              setShowModal(false);
            }}
            showClose={true}
            sx={{
              width: { xs: "90%", sm: "60%", md: "80%", lg: "50%", xl: "50%" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                alignItems: "center",
              }}
            >
              <Box
                component={"img"}
                src={failure_icon?.data?.attributes?.url}
                alt={hsi_info_title}
              />
              <Box
                sx={{
                  fontSize: "24px",
                  fontWeight: "var(--font_weight_4)",
                  lineHeight: "30px",
                  fontFamily: "var(--font_family_Bold)",
                  textAlign: "center",
                }}
              >
                {hsi_info_title}
              </Box>
              <Box
                sx={{
                  fontSize: "16px",
                  fontWeight: "var(--font_weight_0)",
                  lineHeight: "28px",
                  fontFamily: "var(--font_family_Medium)",
                  textAlign: "center",
                }}
              >
                {hsi_info_subtitle}
              </Box>
            </Box>
          </SimpleModal>
          {selectedPlanDetail.length > 0 ? (
            <Box
              sx={{
                backgroundColor: "var(--white)",
                width: "100%",
                padding: "10px 0px",
                position: "fixed",
                bottom: "0px",
                height: { xs: "auto" },
                zIndex: "999",
                boxShadow: "0px 0px 4px 2px #00000026",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: { xs: "column", md: "row" },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: { xs: "column", md: "column" },
                    }}
                  >
                    <Typography
                      sx={{
                        color: "var(--pink-red)",
                        fontSize: { xs: "24px", md: "60px" },
                        fontFamily: "var(--font_family_Bold)",
                      }}
                    >
                      $
                      {selectedPlanDetail
                        .reduce((tot: any, arr: any) => {
                          return (
                            tot +
                            caclulatePlanCostBasedOnEligibility(
                              arr?.plan?.baseLinePrice,
                              unlimitedPlanDiscount?.data[0]?.discountInDollar
                            )
                          );
                        }, 0)
                        .toFixed(2)}
                    </Typography>
                    <Typography
                      sx={{
                        color: "var(--text_color_12)",

                        fontFamily: "var(--font_family_Bold)",
                      }}
                    >
                      {selectedPlanDetail.length}{" "}
                      {selectedPlanDetail.length === 1
                        ? plan_features?.line_selected
                        : lines_selected}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      marginLeft: "15px",
                      borderLeft: { xs: "none", md: "1px solid #004282" },
                      padding: "0px 25px",
                    }}
                  >
                    {filteredPlans &&
                      Object.keys(filteredPlans).map((displayName: any) => {
                        return (
                          <Typography
                            sx={{
                              fontSize: { xs: "12px", md: "18px" },
                              fontFamily: "var(--font_family_Bold)",
                              padding: "2px",
                            }}
                            key={displayName}
                          >
                            {filteredPlans[displayName]} - {displayName}
                          </Typography>
                        );
                      })}
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "center" },
                    marginTop: { xs: "10px", md: "0" },
                  }}
                >
                  <ButtonCust
                    sx={{
                      width: "230px",
                      marginBottom: { xs: "20px", sm: "0px" },
                    }}
                    variantType={Config.PRIMARY_BUTTON_TYPE}
                    data-testid="selectPlanHandlerissimpaid"
                    onClick={(e: any) => {
                      if (EnvConfig?.IS_SSO_LOGIN && ssoAccessToken) {
                        // if (unlimitedPlans.maxLines >= selectedLine) {
                        //   selectPlanHandler(e, "byTheGig");
                        // }
                        navigate(RoutingURLs.checkout);
                      } else {
                        if (EnvConfig.SHOW_SSO_MODAL) {
                          setShowSSOModal(true);
                          dispatch(showSSOModalFn(true));
                        } else {
                          window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`;
                        }
                      }
                      gtmTagManager({
                        event: globalVal?.gtmEvents?.proceedToCheckout,
                        click_section: "home",
                      });
                    }}
                    // disabled={isSimPaid || customerEligibility ? true : false}
                  >
                    {checkout_cta}
                  </ButtonCust>
                </Box>
              </Box>
            </Box>
          ) : null}
        </Box>
        <Box
          sx={{
            width: "100%",
          }}
        >
          <NutritionLabel
            NLContent={planContent}
            plandata={plandata}
            priceCalculationHandler={priceCalculationHandler}
            selectedLine={selectedLine}
          />
        </Box>
        <Box
          sx={{
            mb: "30px",
            width: { xs: "95%", sm: "55%" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography
                my={2}
                sx={{
                  color: "var(--text_color_12)",
                  fontSize: { xs: "14px", sm: "16px" },
                  fontFamily: "var(--font_family_Medium)",
                  textAlign: "center",
                }}
              >
                {plan_features?.disclaimer?.replace(
                  /discountAmount/g,
                  unlimitedPlanDiscount.data[0].discountInDollar || ""
                )}{" "}
                <a
                  href={plan_features?.disclaimer_terms_link}
                  target={plan_features?.isSameWindow ? "_self" : "_blank"}
                >
                  <Box
                    component="span"
                    my={2}
                    sx={{
                      color: "var(--text_color_12)",
                      fontSize: { xs: "14px", sm: "16px" },
                      fontFamily: "var(--font_family_Medium)",
                      textDecoration: "underline",
                    }}
                  >
                    {plan_features?.disclaimer_terms}
                  </Box>
                </a>
              </Typography>
            </Box>
          </Box>
        </Box>
      </>
    )
  );
};

export default T11_PlanCard;
